import { ref } from "vue";

export function useConfirm() {
    const open = ref(false);
    const options = ref({
        title: "Confirmare",
        message: "",
        confirmText: "Confirm",
        cancelText: "Renunță",
        confirmVariant: "danger",
    });

    let _resolve = null;

    const confirm = (opts = {}) => {
        options.value = { ...options.value, ...opts };
        open.value = true;

        return new Promise((resolve) => {
            _resolve = resolve;
        });
    };

    const onConfirm = () => {
        open.value = false;
        _resolve?.(true);
        _resolve = null;
    };

    const onCancel = () => {
        open.value = false;
        _resolve?.(false);
        _resolve = null;
    };

    return { open, options, confirm, onConfirm, onCancel };
}